import React from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header4";
import Footer from "../layout/footer";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const bg2 = require("./../../images/background/bg1.jpg");
const bnr3 = require("./../../images/banner/demag.png");

const About2 = () => {
  const { t } = useTranslation();

  const stats = [
    { count: 124, text: t("about.stats.employees") },
    { count: 60, text: t("about.stats.metalItems") },
    { count: 28, text: t("about.stats.plasticItems") },
    { count: 20, text: t("about.stats.partners") },
  ];

  return (
    <>
      <Helmet>
        <title>{t("about.metaTitle")}</title>
        <meta name="description" content={t("about.metaDescription")} />
        <meta property="og:title" content={t("about.metaTitle")} />
        <meta
          property="og:description"
          content="Nous créons des solutions innovantes pour l'industrie de l'emballage plastique et métallique."
        />
        <meta property="og:image" content={bnr3} />
        <meta
          property="og:url"
          content="https://gargouri-emballages.com/about"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Header />
      <div className="page-content bg-white">
        <div
          className="dlab-bnr-inr overlay-black-middle bg-pt"
          style={{ backgroundImage: `url(${bnr3})` }}
        >
          <div className="container">
            <div className="dlab-bnr-inr-entry">
              <h1 className="text-white">{t("about.title")}</h1>
              <div className="breadcrumb-row">
                <ul className="list-inline">
                  <li>
                    <Link to="/">{t("about.breadcrumb.home")}</Link>
                  </li>
                  <li>{t("about.breadcrumb.about")}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="content-block">
          <div className="section-full content-inner bg-white">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-12 mb-4">
                  <div className="our-story">
                    <span>{t("about.ourStory")}</span>
                    <h2 className="title">
                      {t("about.flourishingLine1")} <br />
                      {t("about.flourishingLine2")} <br />
                      <span style={{ color: "grey" }}>{t("about.since")}</span>
                    </h2>
                    <h4 className="title">{t("about.subtitle")}</h4>
                    <p>{t("about.description")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="section-full box-about-list">
            <div className="row spno">
              <div className="col-lg-6 col-md-12">
                <img
                  src={require("../../images/demag.jpg")}
                  alt=""
                  className="img-cover"
                />
              </div>
              <div className="col-lg-6 col-md-12 bg-primary">
                <div className="max-w700 m-auto p-tb50 p-lr20 text-white">
                  <h2> {t("about.values.title")}</h2>

                  <div className="icon-bx-wraper mb-4 d-flex align-items-center">
                    <div className="icon-md">
                      <Link to="#" className="icon-cell text-white">
                        <i className="flaticon-star"></i>
                      </Link>
                    </div>
                    <div className="icon-content ms-3">
                      <h4 className="dlab-title">
                        {" "}
                        {t("about.values.qualityTitle")}
                      </h4>
                      <p>{t("about.values.qualityDesc")}</p>
                    </div>
                  </div>

                  <div className="icon-bx-wraper mb-4 d-flex align-items-center">
                    <div className="icon-md">
                      <Link to="#" className="icon-cell text-white">
                        <i className="flaticon-checked"></i>
                      </Link>
                    </div>
                    <div className="icon-content ms-3">
                      <h4 className="dlab-title">
                        {" "}
                        {t("about.values.rigorTitle")}
                      </h4>
                      <p>{t("about.values.rigorDesc")}</p>
                    </div>
                  </div>

                  <div className="icon-bx-wraper mb-4 d-flex align-items-center">
                    <div className="icon-md">
                      <Link to="#" className="icon-cell text-white">
                        <i className="flaticon-hygiene"></i>
                      </Link>
                    </div>
                    <div className="icon-content ms-3">
                      <h4 className="dlab-title">
                        {t("about.values.hygieneTitle")}
                      </h4>
                      <p>{t("about.values.hygieneDesc")}</p>
                    </div>
                  </div>

                  <div className="icon-bx-wraper mb-4 d-flex align-items-center">
                    <div className="icon-md">
                      <Link to="#" className="icon-cell text-white">
                        <i className="flaticon-respect"></i>
                      </Link>
                    </div>
                    <div className="icon-content ms-3">
                      <h4 className="dlab-title">
                        {t("about.values.respectTitle")}
                      </h4>
                      <p>{t("about.values.respectDesc")}</p>
                    </div>
                  </div>

                  <div className="icon-bx-wraper mb-4 d-flex align-items-center">
                    <div className="icon-md">
                      <Link to="#" className="icon-cell text-white">
                        <i className="flaticon-team"></i>
                      </Link>
                    </div>
                    <div className="icon-content ms-3">
                      <h4 className="dlab-title">
                        {" "}
                        {t("about.values.teamTitle")}
                      </h4>
                      <p>{t("about.values.teamDesc")}</p>
                    </div>
                  </div>

                  <div className="icon-bx-wraper d-flex align-items-center">
                    <div className="icon-md">
                      <Link to="#" className="icon-cell text-white">
                        <i className="flaticon-transparency"></i>
                      </Link>
                    </div>
                    <div className="icon-content ms-3">
                      <h4 className="dlab-title">
                        {t("about.values.transparencyTitle")}
                      </h4>
                      <p>{t("about.values.transparencyDesc")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="section-full content-inner overlay-black-dark bg-img-fix"
            style={{ backgroundImage: `url(${bg2})` }}
          >
            <div className="container">
              <div className="section-content text-center text-white">
                <div className="row">
                  {stats.map((item, index) => (
                    <div
                      key={index}
                      className="col-lg-3 col-md-6 col-sm-6 col-6 mb-4"
                    >
                      <div className="counter-style-5">
                        <div className="counter">{item.count}</div>
                        <span className="counter-text">{item.text}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default About2;
